import Dexie, { Table } from 'dexie';

export interface QueuedUpload {
  id?: number;
  type: 'photo' | 'asphalt_photo' | 'truck_ticket' | 'daily_report' | 'tm_ticket' | 'equipment_issue' | 'asphalt_report' | 'equipment_repair' | 'equipment_repair_update' | 'receipt';
  status: 'pending' | 'uploading' | 'completed' | 'failed';
  data: any; // The form data/payload
  files?: QueuedFile[]; // Associated files
  jobId?: number;
  employeeId: number;
  createdAt: Date;
  uploadedAt?: Date;
  error?: string;
  retryCount: number;
}

export interface QueuedFile {
  id?: number;
  uploadId: number;
  file: Blob;
  fileBase64?: string; // Store as base64 to avoid iOS IndexedDB Blob corruption
  filename: string;
  fieldName: string; // 'photos', 'signature', etc.
}

// Lock record for coordinating between tabs
export interface ProcessLock {
  id: string; // 'upload-queue-lock'
  tabId: string;
  acquiredAt: number; // timestamp
  expiresAt: number; // timestamp (auto-expire stale locks)
}

export class UploadQueueDB extends Dexie {
  uploads!: Table<QueuedUpload, number>;
  files!: Table<QueuedFile, number>;
  locks!: Table<ProcessLock, string>;

  constructor() {
    super('UploadQueueDB');

    this.version(1).stores({
      uploads: '++id, type, status, jobId, employeeId, createdAt',
      files: '++id, uploadId'
    });

    // Add locks table for tab coordination
    this.version(2).stores({
      uploads: '++id, type, status, jobId, employeeId, createdAt',
      files: '++id, uploadId',
      locks: 'id'
    });
  }
}

export const uploadQueueDB = new UploadQueueDB();
